import { useAppSelector } from '@/app/hooks';
import { selectIsInDineIn, selectTableSession } from './tableSessionSlice';
import { useGetTableSessionQuery } from './tableSessionApi';
import { useTableSessionPollInterval } from './useTableSessionPollInterval';

/**
 * Spec 2026-08-28-dine-in-paid-table-ordering-lock — le convive a réglé sa
 * table depuis son téléphone, elle ne prend plus de commande de sa part.
 *
 * La décision est ENTIÈREMENT serveur (`session.ordering_locked`) : le front ne
 * la recompose pas depuis `is_paid`, qui oscille et vaut déjà faux pour une
 * table buffet sans commande. Un jeton serveur reçoit toujours `false` — le
 * verrou ferme la commande au convive, il ne retire pas la table au personnel.
 *
 * S'abonne au sondage 5 s déjà en place (dédupliqué par RTK Query avec
 * TablePanel / useSharedTableCart) et se coupe quand l'onglet est caché, comme
 * les autres sondeurs. Hors service à table : toujours `false`, aucun écran de
 * la commande en ligne classique ne doit se griser.
 */
export function useTableOrderingLock(): boolean {
  const isInDineIn = useAppSelector(selectIsInDineIn);
  const session = useAppSelector(selectTableSession);
  const guestToken = session?.guestToken ?? '';

  const pollingInterval = useTableSessionPollInterval();

  const { data } = useGetTableSessionQuery(
    {
      restaurantUuid: session?.restaurantUuid ?? '',
      sessionUuid: session?.sessionUuid ?? '',
      guestToken,
    },
    {
      skip: !isInDineIn || !guestToken,
      pollingInterval,
    },
  );

  if (!isInDineIn) return false;
  // Un serveur plus ancien n'envoie pas le champ : l'absence vaut « ouverte ».
  // Bloquer sur un champ manquant fermerait la commande à tout le monde.
  return data?.ordering_locked === true;
}
